/**
 * icons.tsx
 *
 * Builds the iconMap from individual icon files.
 * Each icon lives in its own PascalCase file.
 *
 * This module maps those components to the string keys used by:
 *
 * <Icon name="home" />
 * <Icon name="arrowLeft" />
 * <Icon name="instagram" />
 */

// ** Custom icons
import { XIcon } from './set/XIcon';
import { EyeIcon } from './set/EyeIcon';
import { RSSIcon } from './set/RSSIcon';
import { HomeIcon } from './set/HomeIcon';
import { XingIcon } from './set/XingIcon';
import { CloseIcon } from './set/CloseIcon';
import { GraphIcon } from './set/GraphIcon';
import { TableIcon } from './set/TableIcon';
import { VimeoIcon } from './set/VimeoIcon';
import { TikTokIcon } from './set/TikTokIcon';
import { RedditIcon } from './set/RedditIcon';
import { TwitchIcon } from './set/TwitchIcon';
import { BurgerIcon } from './set/BurgerIcon';
import { EventsIcon } from './set/EventsIcon';
import { GitHubIcon } from './set/GitHubIcon';
import { GitLabIcon } from './set/GitLabIcon';
import { OnlineIcon } from './set/OnlineIcon';
import { SearchIcon } from './set/SearchIcon';
import { ChevronIcon } from './set/ChevronIcon';
import { ThreadsIcon } from './set/ThreadsIcon';
import { DiscordIcon } from './set/DiscordIcon';
import { BlueskyIcon } from './set/BlueskyIcon';
import { ProfileIcon } from './set/ProfileIcon';
import { SpotifyIcon } from './set/SpotifyIcon';
import { YouTubeIcon } from './set/YouTubeIcon';
import { WhatsAppIcon } from './set/WhatsAppIcon';
import { TelegramIcon } from './set/TelegramIcon';
import { DownloadIcon } from './set/DownloadIcon';
import { FacebookIcon } from './set/FacebookIcon';
import { LinkedInIcon } from './set/LinkedinIcon';
import { MastodonIcon } from './set/MastodonIcon';
import { PraesenzIcon } from './set/PraesenzIcon';
import { SnapchatIcon } from './set/SnapchatIcon';
import { ArrowLeftIcon } from './set/ArrowLeftIcon';
import { PinterestIcon } from './set/PinterestIcon';
import { FavoritesIcon } from './set/FavoritesIcon';
import { InstagramIcon } from './set/InstagramIcon';
import { ArrowRightIcon } from './set/ArrowRightIcon';
import { SelectChevronIcon } from './set/SelectChevronIcon';
import { SketchyEllipseIcon } from './set/SketchyEllipseIcon';
import { ArrowSmallRightIcon } from './set/ArrowSmallRightIcon';

// ** Temporary MUI icons
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';

export const iconMap = {
	x: XIcon,
	eye: EyeIcon,
	rss: RSSIcon,
	home: HomeIcon,
	xing: XingIcon,
	close: CloseIcon,
	graph: GraphIcon,
	table: TableIcon,
	vimeo: VimeoIcon,
	reddit: RedditIcon,
	tiktok: TikTokIcon,
	twitch: TwitchIcon,
	burger: BurgerIcon,
	events: EventsIcon,
	github: GitHubIcon,
	gitlab: GitLabIcon,
	online: OnlineIcon,
	search: SearchIcon,
	bluesky: BlueskyIcon,
	chevron: ChevronIcon,
	discord: DiscordIcon,
	profile: ProfileIcon,
	spotify: SpotifyIcon,
	threads: ThreadsIcon,
	youtube: YouTubeIcon,
	download: DownloadIcon,
	facebook: FacebookIcon,
	linkedin: LinkedInIcon,
	mastodon: MastodonIcon,
	praesenz: PraesenzIcon,
	snapchat: SnapchatIcon,
	telegram: TelegramIcon,
	whatsapp: WhatsAppIcon,
	arrowLeft: ArrowLeftIcon,
	favorites: FavoritesIcon,
	instagram: InstagramIcon,
	pinterest: PinterestIcon,
	arrowRight: ArrowRightIcon,
	dashboard: SpaceDashboardIcon,
	selectChevron: SelectChevronIcon,
	sketchyEllipse: SketchyEllipseIcon,
	arrowSmallRight: ArrowSmallRightIcon
} as const;

export type IconName = keyof typeof iconMap;
